import React, { useState } from "react";
import styled from "styled-components";

// Define our card components with styled-components
const Card = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 16px;
  overflow: hidden;
  width: "100%";
`;

const Title = styled.h1`
  background-color: #f2f2f2;
  color: #333;
  padding: 16px;
  margin: 0;
  font-size: 18px;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

const Checkmark = styled.span`
  color: orangered;
  font-size: 16px;
`;

const Button = styled.button`
  background-color: #000;
  color: white;
  font-size: 14px;
  width: 70%;
  padding: 12px;
  border: none;
  text-transform: uppercase;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  margin: auto;
`;

const Disclaimer = styled.p`
  color: #666;
  font-size: 10px;
  padding: 12px 16px;
  background-color: #f8f8f8;
  margin: 0;
`;

// Create the React component
const ServicesMobileView = ({ title, serviceList1, serviceList2 }) => {
  const [isViewMore, setIsViewMorw] = useState(false);

  const handleViewMore = () => {
    setIsViewMorw(true);
  };

  const btnText = isViewMore ? "Book Now" : "View More";

  console.log("serviceList1", serviceList1);

  return (
    <Card>
      <Title>{title}</Title>
      {serviceList1.map((item) => (
        <List>
          <ListItem>
            <span>{item}</span>
            <Checkmark>✔</Checkmark>
          </ListItem>
        </List>
      ))}
      {isViewMore && (
        <>
          {serviceList2?.map((item) => (
            <List>
              <ListItem>
                <span>{item}</span>
                <Checkmark>✔</Checkmark>
              </ListItem>
            </List>
          ))}
        </>
      )}
      <Button
        onClick={handleViewMore}
        style={{ background: isViewMore ? "orangered" : "black" }}
      >
        {btnText}
      </Button>
      <Disclaimer>
        * Specialist oil or different grades of oil may be required for your
        vehicle that will incur an additional cost. This will be quoted to you
        on the day of the service.
        <br />* Spark plugs replacement labor will require a minimum of 1 Hour
        labor and may be more depending on your vehicle model and if your
        vehicle requires a spark plug change. This labor price will be quoted to
        you on the day of your service.
      </Disclaimer>
    </Card>
  );
};

export default ServicesMobileView;
